var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.926 2.926a10.02 10.02 0 0 1 14.149 0 10.02 10.02 0 0 1 0 14.149 10.02 10.02 0 0 1-14.149 0 10.02 10.02 0 0 1 0-14.149zm9.932 11.02a.77.77 0 0 0 1.088 0 .77.77 0 0 0 0-1.088L11.088 10l2.72-2.72a.77.77 0 0 0 0-1.088.77.77 0 0 0-1.088 0L10 8.912 7.143 6.055a.77.77 0 0 0-1.088 0 .77.77 0 0 0 0 1.088L8.912 10 5.92 12.993a.77.77 0 0 0 0 1.088.77.77 0 0 0 1.088 0L10 11.088l2.857 2.857z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "media/e5406105.svg";
export { SvgPasswordError as ReactComponent };